import React from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Installation from './components/Installation'
import CommentJouer from './components/CommentJouer'
import Features from './components/Features'
import Evolution from './components/Evolution'
import Footer from './components/Footer'
import './App.css'

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Installation />
        <CommentJouer />
        <Features />
        <Evolution />
      </main>
      <Footer />
    </div>
  )
}

export default App
